import { Tooltip, Typography, styled } from '@mui/material'
import { memo } from 'react'
import { colorPalette } from '../../../../style/colorPalette'

type Props = {
  path?: string
  parentDisplayName?: string
  code?: string
}

export const ProjectPlanPath = memo(
  ({ path, parentDisplayName, code }: Props) => {
    return (
      <StyledWrapper>
        {code && <StyledCode>{code}</StyledCode>}
        <Tooltip title={path ?? ''} placement="top">
          <StyledContainer>
            <StyledPrefix>... /</StyledPrefix>
            <Typography
              component="div"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {parentDisplayName}
            </Typography>
            <StyledSuffix>/</StyledSuffix>
          </StyledContainer>
        </Tooltip>
      </StyledWrapper>
    )
  }
)

const StyledWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
  width: '100%',
})

const StyledContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  minWidth: 0,
  fontWeight: '400',
  color: colorPalette.monotone[4],
})

const StyledPrefix = styled('p')({
  margin: '0 5px 0 0',
  flexShrink: 0,
})

const StyledSuffix = styled('p')({
  margin: '0 0 0 5px',
  flexShrink: 0,
})

const StyledCode = styled('div')({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  fontWeight: '600',
  fontSize: '11px',
  color: colorPalette.monotone[10],
})
